import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {TelegramService} from '../telegram.service';
import {isUndefined} from 'util';
import {NotifierWrapService} from '../../../services/notifier-wrap.service';
import {AllService} from '../../../services/all.service';
import {AllMessengersService} from '../../page-start/all-messengers.service';
import {SenderService} from '../../../services/sender.service';
import {InterfaceService} from '../../../services/interface.service';
import {ModalService} from '../../../services/modal.service';
import {AuthService} from '../../../modules/auth/services/auth.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-sign-telegram',
  templateUrl: './sign-telegram.component.html',
  styleUrls: ['./sign-telegram.component.scss']
})
export class SignTelegramComponent implements OnInit {
  @Input() type = 'telegram';
  _isLoading = false;
  Form: UntypedFormGroup;
  FormCode: UntypedFormGroup;
  FormPassword: UntypedFormGroup;
  arCode: any = {};
  sessionPasswordNeeded = false;
  @ViewChild('inputPassword') inputPassword: ElementRef;
  @ViewChild('inputCode') inputCode: ElementRef;
  telegramService: TelegramService;
  tabindex = 0;
  nzLoading = false;
  public lastError: any;

  public environment = environment;
  constructor(
    public authService: AuthService,
    public modalService: ModalService,
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    public allMessengersService: AllMessengersService,
    public allService: AllService,
    public cd: ChangeDetectorRef,
    public notifierWrapService: NotifierWrapService
  ) {
  }

  ngOnInit() {
    this.resetService();
    this.initForms();
    setTimeout(() => {
      this.cd.detectChanges();
    }, 1000);
  }
  resetService(): void {
    console.log('Reset service');
    const arFreeServices = this.allMessengersService.getServicesFilter('isAuth', false).filter((v) => v.type.includes('telegram|'));
    if (arFreeServices?.length === 0) {
      this.notifierWrapService.notify('error', 'Закончились свободные слоты для авторизации, напишите нам.');
    } else if (arFreeServices[0] instanceof TelegramService) {
      const Service = arFreeServices[0];
      console.log('SetRandToken', Service);
      Service.resetToken();
      this.telegramService = Service;
    }
  }
  initForms() {
    this.Form = new UntypedFormGroup({
      phone: new UntypedFormControl('', Validators.required)
    });
    this.FormCode = new UntypedFormGroup({
      code: new UntypedFormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)])
    });
    this.FormCode.get('code').valueChanges.subscribe((code) => {
      if (code?.toString()?.length === 5) {
        setTimeout(() => {
          this.checkCode();
        }, 250);

      }
    });
    this.FormPassword = new UntypedFormGroup({
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(1)])
    });
  }

  get allTokens() {
    return this.senderService.authTokens.push(this.telegramService.token);
  }

  sendCode() {
    this.resetService();
    delete this.lastError;
    this.isLoading = true;
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    this.telegramService.sendCode(values.phone, this.senderService.authTokens).subscribe(
      (result: any) => {
        this.arCode = result;
        setTimeout(() => {
          this.inputCode.nativeElement.focus();
        }, 200);
        this.isLoading = false;
      },
      (error) => {
        this.lastError = error;
        this.isLoading = false;
      }
    );
  }
  resendCode() {
    delete this.lastError;
    this.isLoading = true;
    const values = this.Form.value;
    this.telegramService.resendCode(values.phone, this.arCode.phone_code_hash).subscribe(
      (result: any) => {
        this.arCode = result;
        setTimeout(() => {
          this.inputCode.nativeElement.focus();
        }, 200);
        this.isLoading = false;
      },
      (error) => {
        this.arCode = {};
        this.lastError = error;
        this.isLoading = false;
      }
    );
  }
  checkCode() {
    delete this.lastError;
    this.isLoading = true;
    const controls = this.FormCode.controls;
    const values = this.FormCode.value;
    // Проверяем форму на валидность */
    if (this.FormCode.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.telegramService.checkCode(
      this.arCode.phone_code_hash, values.code,
      this.Form.value.phone, this.senderService.authTokens,
      this.senderService.partnerId
    ).subscribe(
      (result: any) => {
        this.senderService.setAccount(result.account, this.telegramService);
        this.telegramService.setAuth();
        this.telegramService.loadProfile();
        this.goPage();
        this.isLoading = false;
      },
      (error) => {
        const detail = error?.error.detail;
        if (detail.error_id) {
          if (detail.error_id === 'SESSION_PASSWORD_NEEDED') {
            this.sessionPasswordNeeded = true;
            setTimeout(() => {
              this.inputPassword.nativeElement.focus();
            }, 200);
          } else if (detail.error_id === 'PHONE_CODE_EXPIRED') {
            this.arCode = {};
            this.cd.detectChanges();
          } else {
            this.lastError = error;
          }
          this.FormCode.get('code').setValue('');
        } else {
          this.lastError = error;
        }
        this.isLoading = false;
      }
    );
  }

  checkPassword() {
    delete this.lastError;
    const controls = this.FormPassword.controls;
    const values = this.FormPassword.value;
    // Проверяем форму на валидность */
    if (this.FormPassword.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.isLoading = true;
    this.telegramService.checkPassword(values.password, this.senderService.authTokens, this.senderService.partnerId).subscribe(
      (result: any) => {
        if (!isUndefined(result.auth)) {
          this.senderService.setAccount(result.account, this.telegramService);
          this.telegramService.setAuth();
          this.telegramService.loadProfile();
          this.goPage();
        }
        this.isLoading = false;
      },
      (error) => {
        const detail = error?.error?.detail;
        if (detail?.error_id === 'AUTH_KEY_UNREGISTERED') {
          this.arCode = {};
          this.sessionPasswordNeeded = false;
        }
        this.FormPassword.get('password').setValue('');
        this.lastError = error;
        this.isLoading = false;
      }
    );
  }

  authDemo() {
    /*this.allService.token = 'u7l5u6g2nnfcro07ivybnppjlt9bwmdts';
    this.telegramService.token = 'u7l5u6g2nnfcro07ivybnppjlt9bwmdts';
    localStorage.setItem('token', this.telegramService.token);
    this.telegramService.setToken();
    this.telegramService.setAuth();
    this.telegramService.loadProfile();

    this.allMessengersService.setServiceActive(this.telegramService.type, true);
    this.allService.setService$.next(this.telegramService);

    this.goPage();*/
  }

  goPage(): void {
    // this.router.navigate([`/${this.telegramService.type}/`]);
  }

  get isLoading() {
    return this._isLoading;
  }

  set isLoading(val) {
    this._isLoading = val;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 100);
  }

  backLogin() {
    this.arCode.phone_code_hash = false;
    this.Form.get('phone').reset();
    this.cd.detectChanges();
  }

  nzSelectedIndexChange($event: any) {
    this.tabindex = $event;
    this.cd.detectChanges();
    setTimeout(() => {
      this.cd.detectChanges();
    }, 100);
  }
}
